import { DEFAULT_SORTING_HELLO_RETAIL } from './filter';

export type FacetList = { [key: string]: string[] };

export const defaultHelloRetailSortOption = { query: DEFAULT_SORTING_HELLO_RETAIL, title: 'Relevans' };
